import React from "react";
import { UsersTableWrapper } from "./components/UsersTableWrapper/UsersTableWrapper";
import { WorksTableWrapper } from "./components/WorksTableWrapper/WorksTableWrapper";

export const AdminPage = ({ type }) => {
  if (type === "users") return <UsersTableWrapper />;
  if (type === "jobs") return <WorksTableWrapper />;
};
